/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import Asset, {
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface slidesStruct {
  title ? : string;
  subTitle ? : string;
  image ? : Asset;
  alt ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  ctaLink ? : Array < ctaLinkStruct > ;
  category ? : Array < any > ;
}
export default interface Top {
  topTitle ? : string;
  topTitleColor ? : number;
  slides ? : Array < slidesStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  topTitle: String,
  topTitleColor: Number,
  slides: Array as() => Array < slidesStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  topTitle: String,
  topTitleColor: Number,
  slides: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class TopBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class TopInstance implements Top {
      topTitle ? : string;
      topTitleColor ? : number;
      slides ? : Array < slidesStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.slides) {
          this.slides = Object.entries(this.slides)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'slides' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.slides.length; i1++) {
            if (this.slides[i1]) {
              if (typeof this.slides[i1].image === 'object') {
                this.slides[i1].image = {
                  ...this.slides[i1].image,
                  link: this.slides[i1].image['@link'],
                  name: this.slides[i1].image['@name'],
                  path: this.slides[i1].image['@path'],
                };
              } else {
                this.slides[i1].image = null as any;
              }
            }
            if (this.slides[i1]) {
              if (this.slides[i1].mobileAspectRatio) {
                this.slides[i1].mobileAspectRatio = Object.entries(this.slides[i1].mobileAspectRatio)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.slides[i1].mobileAspectRatio = null as any;
              }
            }
            if (this.slides[i1]) {
              if (this.slides[i1].ctaLink) {
                this.slides[i1].ctaLink = Object.entries(this.slides[i1].ctaLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.slides[i1].ctaLink.length; i2++) {

                  if (this.slides[i1]) {
                    if (this.slides[i1].ctaLink[i2]) {
                      if (this.slides[i1].ctaLink[i2].switchable) {
                        if (typeof this.slides[i1].ctaLink[i2].switchable.download === 'object') {
                          this.slides[i1].ctaLink[i2].switchable.download = {
                            ...this.slides[i1].ctaLink[i2].switchable.download,
                            link: this.slides[i1].ctaLink[i2].switchable.download['@link'],
                            name: this.slides[i1].ctaLink[i2].switchable.download['@name'],
                            path: this.slides[i1].ctaLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.slides[i1].ctaLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.slides[i1].ctaLink = null as any;
              }
            }
          }
        } else {
          this.slides = null as any;
        }
      }
    }
    return new TopInstance(props);
  }
}
